import { connect } from 'react-redux';
import actions from 'actions/Chat';
import { searchSelectors } from '@lifesize/nucleus';
import ChatSearchComp from 'components/Chat/Search/ChatSearch';
import _get from 'lodash/get';

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleSetIsFocused: (isFocused) => {
    dispatch(actions.setFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    ownProps.onSelectContact(selectedContact);
  }
});

function getMaxItems(searchResults) {
  const resultLength = searchResults.length
    || 1;
  return Math.min(resultLength, 6);
}

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.chatSearch.values.chatSearchBar');
  const searchResults = searchSelectors.searchChattableContacts(state);
  const isFocused = _get(state, 'app.chat.isFocused');
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  const selectedContact = _get(searchResults[selectionIndex], 'contact');

  return {
    searchResults,
    searchString,
    maxItems: getMaxItems(searchResults),
    isFocused,
    selectedContact
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatSearchComp);
